import { useState } from "react";
import { Eye, ExternalLink } from "lucide-react";
import { fmtAmountRaw, fmtDate } from "@/lib/render";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const FIELDS = [
  ["Type", "type"], ["Status", "status"], ["Network", "network"], ["Mode", "network_mode"], ["Chain ID", "chain_id"],
  ["From", "from_address"], ["To", "to_address"], ["Token contract", "token_contract"], ["Nonce", "nonce"],
];

export const CryptoTxDetailsButton = ({ row }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant="ghost" size="icon" onClick={() => setOpen(true)} data-testid="crypto-tx-view"
        className="text-muted-foreground hover:text-foreground hover:bg-muted h-8 w-8">
        <Eye className="h-4 w-4" />
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-card border-border text-foreground max-w-lg" data-testid="crypto-tx-details-dialog">
          <DialogHeader>
            <DialogTitle className="font-display">Crypto transaction</DialogTitle>
            <DialogDescription className="text-muted-foreground font-mono">
              {fmtAmountRaw(row.amount)} {row.currency} · {fmtDate(row.created_at)}
            </DialogDescription>
          </DialogHeader>
          <div className="rounded-lg border border-indigo-500/30 bg-indigo-500/5 p-3 space-y-2">
            <p className="text-xs uppercase tracking-wider text-indigo-500">Transaction hash</p>
            <code className="font-mono text-xs break-all block">{row.tx_hash || "—"}</code>
            {row.explorer_url ? (
              <a href={row.explorer_url} target="_blank" rel="noopener noreferrer" data-testid="crypto-tx-explorer-link"
                className="inline-flex items-center gap-1 text-xs text-indigo-500 hover:underline">
                View on block explorer <ExternalLink className="h-3 w-3" />
              </a>
            ) : <p className="text-xs text-muted-foreground">No explorer link (not broadcast through CITIDAN)</p>}
          </div>
          <div className="divide-y divide-border">
            {FIELDS.filter(([, k]) => row[k] != null && row[k] !== "").map(([label, k]) => (
              <div key={k} className="flex justify-between gap-4 py-2">
                <span className="text-xs uppercase tracking-wider text-muted-foreground">{label}</span>
                <span className="text-xs font-mono text-right break-all">{String(row[k])}</span>
              </div>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
